export default new class ErrorManager {
   parseResponseError(data) {
       if (data.hasOwnProperty('success') && !data.success) {
           window.OPWrapperService.showError(data.code, data.message, data.isReload);
       }
       return data;
   }
}
